@if (product && providerProduct && store && providerSettings) {
  <div class="text-surface-900 dark:text-surface-0 font-medium p-4 pb-0 text-3xl">
    <div>
      @if (providerSettings.brand.supporting) {
        <span>Marka</span>
      }
      @if (providerSettings.brand.supporting && providerSettings.category.supporting) {
        <span> ve </span>
      }
      @if (providerSettings.category.supporting) {
        <span>Kategori</span>
      }
      <span> Eşleştirme</span>
    </div>
    <div>
      @if (matchingAutoComplete()) {
        @for (message of messages; track $index) {
          <div class="card mt-2">
            <p-message icon="pi pi-info-circle" [severity]="message.severity"
            >{{ message.detail }}
            </p-message>
          </div>
        }
      }
    </div>
  </div>

  <div class="grid grid-cols-12 gap-4 -mr-4 -ml-4 mt-2 lg:mt-0">
    <div class="col-span-12 px-0 lg:p-4">
      <div class="px-0 py-6 lg:px-6 bg-surface-0 dark:bg-surface-800 rounded-border shadow">
        @if (providerSettings.brand.supporting) {
          <div class="flex">
            <div class="flex flex-col items-center ml-4" style="width:2rem">
                        <span
                          class="  flex items-center justify-center rounded-full"
                          [ngClass]="providerProduct.getBrandName() && providerProduct.getBrandName().length > 0 ? 'bg-green-500 text-surface-0' :'bg-surface-200 text-surface-500'"
                          style="min-width:3rem; min-height: 3rem">
                            <i class="pi pi-directions text-xl"></i>
                        </span>
              <div
                class="h-full border-dashed border  "
                [ngClass]="providerProduct.getBrandName() && providerProduct.getBrandName().length > 0 ? 'border-green-500': 'surface-border'"
                style="min-height: 12rem"></div>
            </div>
            <div class="ml-0 lg:ml-8 p-2 flex-auto">
              <div class="mb-4">
                <span class="text-surface-900 dark:text-surface-0 text-xl block ml-2">Marka Eşleştirme</span>
              </div>
              <div class="grid grid-cols-12 gap-4 flex-col lg:flex-row">
                <div class="col-span-12 lg:col-span-6 p-4">
                  <div
                    class="flex flex-col rounded-border border border-surface p-6 cursor-pointer hover:border-primary duration-150"
                    [ngClass]="{'border-primary': true}">
                    <div class="flex justify-between mb-4">
                      <span
                        class="text-surface-900 dark:text-surface-0 text-xl font-medium h-full">Ana Ürün Markası</span>

                    </div>
                    @if (product && store) {
                      <span
                        class="inline-block text-surface-600 dark:text-surface-200 mb-4">{{ product.BrandId | fieldsPipe : store.brands.brandFields }}</span>
                      <span class="inline-block text-surface-600 dark:text-surface-200"> <i
                        class="pi pi-info-circle mr-2"></i>Ana Ürün Marka ID: {{ product.BrandId }} </span>
                    }
                  </div>
                </div>

                @if (providerProduct.getBrandName() && providerProduct.getBrandName().length > 0) {
                  <div class="col-span-12 lg:col-span-6 p-4">
                    <div
                      class="flex flex-col rounded-border border h-full border-surface p-6 cursor-pointer hover:border-primary duration-150"
                      [ngClass]="{'border-primary': true}">
                      <div class="flex justify-between mb-4">
                        <span class="text-surface-900 dark:text-surface-0 text-xl font-medium ">Pazaryeri Markası</span>

                        <div (click)="openBrandSelection()" class="text-surface-600 dark:text-surface-200 font-medium">
                          <i
                            class="pi pi-pencil mr-2"></i>
                          <span class="hidden xl:inline-block">Eşleştirmeyi Düzenle</span>
                        </div>
                      </div>
                      <span
                        class="inline-block text-surface-600 dark:text-surface-200 mb-4">{{ providerProduct.getBrandName() }}</span>
                      <span class="inline-block text-surface-600 dark:text-surface-200"><i
                        class="pi pi-info-circle mr-2"></i>Pazaryeri Marka ID: {{ providerProduct.getBrandId() }}</span>
                    </div>
                  </div>
                } @else if (!providerProduct.getBrandName() || providerProduct.getBrandName().length === 0) {
                  <div class="col-span-12 lg:col-span-6 p-4">
                    <div
                      (click)="openBrandSelection()"
                      class="flex h-full flex-col justify-center items-center py-8 lg:py-0 rounded-border border border-surface bg-surface-100 dark:bg-surface-800 cursor-pointer hover:border-primary duration-150">
                                          <span
                                            class="text-surface-600 dark:text-surface-200 rounded-full border-2 w-8 h-8 flex items-center justify-center"><i
                                            class="pi pi-fw pi-plus"></i></span>
                      <span class="text-surface-600 dark:text-surface-200 mt-4">Yeni Eşleştirme</span>
                    </div>
                  </div>
                }

              </div>
            </div>
          </div>
        }
        <div class="flex">
          <div class="flex flex-col items-center ml-4" style="width:2rem">
                        <span
                          class="flex items-center justify-center rounded-full"
                          [ngClass]="providerCategory && providerCategory!.Path!.length > 0 ? 'bg-green-500 text-surface-0' :'bg-surface-200 text-surface-500'"
                          style="min-width:3rem; min-height: 3rem">
                            <i class="pi pi-directions text-xl"></i>
                        </span>
            @if (providerSettings && providerSettings.category.attributeSupporting && providerSettings.providerGroup !== ProviderGroupEnum.ECommerce && providerCategoryAttributes().length>0 ) {
              <div
                class="h-full border-dashed border  "
                [ngClass]="providerCategory && providerCategory.Path.length > 0 ? 'border-green-500': 'surface-border'"
                style="min-height: 12rem"></div>
            }

          </div>
          <div class="ml-0 lg:ml-8 p-2 flex-auto">
            <div class="mb-4">
              <span class="text-surface-900 dark:text-surface-0 text-xl block ml-2">Kategori Eşleştirme</span>
            </div>
            <div class="grid grid-cols-12 gap-4 flex-col lg:flex-row">
              <div class="col-span-12 lg:col-span-6 p-4">
                <div
                  class="flex flex-col rounded-border border h-full border-surface p-6 cursor-pointer hover:border-primary duration-150"
                  [ngClass]="{'border-primary': true}">
                  <div class="flex justify-between mb-4">
                    <span class="text-surface-900 dark:text-surface-0 text-xl font-medium">Ana Ürün Kategorisi</span>

                  </div>
                  @if (product && store) {
                    <span
                      class="inline-block text-surface-600 dark:text-surface-200 mb-4">{{ product.CategoryId | fieldsPipe : store.categories.categoryFields }}</span>
                    <span class="inline-block text-surface-600 dark:text-surface-200"> <i
                      class="pi pi-info-circle mr-2"></i>Ana Ürün Kategori ID: {{ product.CategoryId }} </span>
                  }
                </div>
              </div>
              @if (providerCategory && providerCategory.Path.length > 0) {
                <div class="col-span-12 lg:col-span-6 p-4">
                  <div
                    class="flex flex-col rounded-border border h-full border-surface p-6 cursor-pointer hover:border-primary duration-150"
                    [ngClass]="{'border-primary': true}">
                    <div class="flex justify-between mb-4">
                      <span class="text-surface-900 dark:text-surface-0 text-xl font-medium">Pazaryeri Kategorisi</span>

                      <div (click)="openCategoriesSelection()"
                           class="text-surface-600 dark:text-surface-200 font-medium">
                        <i
                          class="pi pi-pencil mr-2"></i>
                        <span class="hidden xl:inline-block">Eşleştirmeyi Düzenle</span>
                      </div>
                    </div>
                    <span
                      class="inline-block text-surface-600 dark:text-surface-200 mb-4">{{ providerCategory.Path }}</span>
                    <span class="inline-block text-surface-600 dark:text-surface-200"><i
                      class="pi pi-info-circle mr-2"></i>Pazaryeri Kategori ID: {{ providerCategory.Code }}</span>
                  </div>
                </div>
              } @else {
                <div class="col-span-12 lg:col-span-6 p-4">
                  <div
                    (click)="openCategoriesSelection()"
                    class="flex h-full flex-col justify-center items-center py-8 lg:py-0 rounded-border border border-surface bg-surface-100 dark:bg-surface-800 cursor-pointer hover:border-primary duration-150">
                                        <span
                                          class="text-surface-600 dark:text-surface-200 rounded-full border-2 w-8 h-8 flex items-center justify-center"><i
                                          class="pi pi-fw pi-plus"></i></span>
                    <span class="text-surface-600 dark:text-surface-200 mt-4">Yeni Eşleştirme</span>
                  </div>
                </div>
              }

            </div>
          </div>
        </div>
        @if (providerSettings && providerSettings.category.attributeSupporting && providerSettings.providerGroup !== ProviderGroupEnum.ECommerce && providerCategoryAttributes().length>0) {
          <div class="flex">
            <div class="flex flex-col items-center ml-4" style="width:2rem">
                        <span
                          class="flex items-center justify-center rounded-full"
                          [ngClass]="
                          ((!newAttributes$() &&filteredAttributes.length > 0 ) || emptyValueAttributes)
                          && !providerProduct.validation.CategoryAttribute.status ?  'bg-green-500 text-surface-0' :'bg-surface-200 text-surface-500'"
                          style="min-width:3rem; min-height: 3rem">
                            <i class="pi pi-directions text-xl"></i>
                        </span>


            </div>
            <div class="ml-0 lg:ml-8 pt-2 p-0 flex-auto">
              <div class="mb-1">
                <div class="flex justify-between items-center mb-2">
                  <span class="text-surface-900 dark:text-surface-0 text-xl ml-4">Kategori Özellik Eşleştirme</span>
                  <div (click)="openCategoriesAttributes()"
                       class="text-surface-600 dark:text-surface-200 font-medium px-4 mr-4 cursor-pointer">
                    <i class="pi pi-pencil mr-2"></i>
                    <span class="hidden xl:inline-block">Eşleştirmeyi Düzenle</span>
                  </div>
                </div>

                @if(filteredAttributes.length ===0 && emptyValueAttributes ){
                            <div class="ml-4 mt-1">
                <span class="text-gray-500 dark:text-gray-400 text-sm italic flex items-center">
                  <i class="pi pi-info-circle mr-2"></i>
                  (Bu kategorideki zorunlu olmayan özellikler opsiyoneldir. İsterseniz boş bırakabilir veya daha sonra düzenleyebilirsiniz)
                </span>
                  </div>
                }
              </div>


              @if (!newAttributes$() && filteredAttributes.length > 0) {


                @for (attribute of filteredAttributes; track attribute) {

                    <!--Attribute Name-->
                    <div class="flex flex-col lg:flex-row items-center">
                      <div class="p-4 flex-1 w-full">


                        <div
                          class="flex flex-col rounded-border border h-full lg:w-auto border-surface p-6 py-4 cursor-pointer hover:border-primary duration-150">
                          <div class="flex justify-between mb-4">
                            <span
                              class="text-surface-900 dark:text-surface-0 text-xl font-medium">{{ attribute.Name }}</span>

                          </div>
                          <span class="inline-block text-surface-600 dark:text-surface-200"><i
                            class="pi pi-info-circle mr-2"></i>Özellik Kodu: {{ attribute.Code }}</span>
                        </div>
                      </div>
                      <!--Attribute Name-->

                      <!--Icon-->
                      <div class="flex  justify-center  items-center text-3xl">
                                                      <span class="hidden lg:block ">
                                                         <i class="pi hidden lg:block pi-arrow-right "></i>
                                                      </span>
                        <span class="block lg:hidden">
                                                         <i class="pi block lg:hidden pi-arrow-down"></i>
                                                      </span>


                      </div>
                      <!--Icon-->


                      <!--Attribute Value-->
                      <div class="p-4 flex-1 w-full">
                        <div
                          class="flex flex-col lg:flex-row gap-2 rounded-border border h-full border-surface p-6 py-4 cursor-pointer hover:border-primary duration-150">
                          <div class="flex flex-col gap-4 w-full">
                            <div>
                              <span
                                class="text-surface-900 dark:text-surface-0 text-xl font-medium">{{ attribute.Value }} </span>
                              @if (attribute.IsFaulty) {
                                <span class="lg:hidden" style="float:right"
                                      (click)="openCategoriesAttributes()">
                                                           <i
                                                             pTooltip="Hatalı özellik eşleştirmesi. Seçilen değer bulunamadı. Lütfen, tekrar seçim yapınız"
                                                             class="text-red-500  animate-fadein animate-duration-1000 animate-infinite ml-auto pi pi-exclamation-triangle text-lg"></i>
                                                        </span>
                              }
                            </div>

                            <span class="inline-block text-surface-600 dark:text-surface-200"><i
                              class="pi pi-info-circle mr-2"></i>Özellik Kodu: {{ attribute |attributeKeyFind }}</span>

                          </div>
                          <div class="flex mt-2 lg:mt-0  lg:flex-col lg:items-end justify-between lg:w-3/12">
                            @if (attribute.IsFaulty) {
                              <span class="hidden lg:block"
                                    pTooltip="Hatalı özellik eşleştirmesi. Seçilen değer bulunamadı. Lütfen, tekrar seçim yapınız"
                                    (click)="openCategoriesAttributes()">
                                                           <i

                                                             class="text-red-500 animate-fadein animate-duration-1000 animate-infinite ml-auto pi pi-exclamation-triangle text-lg"></i>
                                                        </span>
                            }

                            <div class="flex">
                              @if (attribute.Compulsory) {
                                <p-chip styleClass="pl-0 pr-4 dark:bg-surface-950">
                                  <span
                                    class="bg-primary text-primary-contrast rounded-full w-8 h-8 flex items-center justify-center">Z</span>
                                  <span class="ml-2 font-medium !mr-2">Zorunlu</span>
                                </p-chip>
                              }

                              @if (attribute.IsVariant) {
                                <p-chip styleClass="pl-0 pr-4 ml-2 dark:bg-surface-950">
                                  <span
                                    class="bg-orange-500 text-white rounded-full w-8 h-8 flex items-center justify-center">V</span>
                                  <span class="ml-2 font-medium !mr-2">Varyant</span>
                                </p-chip>
                              }
                            </div>

                          </div>

                        </div>
                      </div>
                    </div>
                    <!--Attribute Value-->

                    @if ($index !== providerProduct.Attributes.length - 1) {

                      <p-divider styleClass="p-0 m-0 mx-4 w-auto"></p-divider>
                    }

                }

              } @else {
                <!--New Attribute Matching-->
                <div class="col p-4">
                  <div
                    (click)="openCategoriesAttributes()"
                    class="flex  flex-col justify-center h-36 items-center py-8 lg:py-0 rounded-border border border-surface bg-surface-100 dark:bg-surface-800 cursor-pointer hover:border-primary duration-150">
                        <span
                          class="text-surface-600 dark:text-surface-200 rounded-full border-2 w-8 h-8 flex items-center justify-center">
                          <i
                            class="pi"
                            [ngClass]="filteredAttributes.length ===0 && emptyValueAttributes && !newAttributes$() ? 'pi-pencil':'pi-plus'"
                          ></i>
                        </span>
                    <span class="text-surface-600 dark:text-surface-200 mt-4">
                      @if( filteredAttributes.length ===0 && emptyValueAttributes && !newAttributes$()) {
                         Eşleştirmeyi Düzenle
                      }@else{
                        Yeni Eşleştirme
                      }
                    </span>
                  </div>
                </div>
                <!--New Attribute Matching-->

              }

            </div>
          </div>
        }
      </div>
    </div>

  </div>


}
